export default __webpack_public_path__ + "images/set/footer.png";